import { render, staticRenderFns } from "./SearchResourcesPanel.vue?vue&type=template&id=27fd6cc2&scoped=true"
import script from "./SearchResourcesPanel.vue?vue&type=script&lang=js"
export * from "./SearchResourcesPanel.vue?vue&type=script&lang=js"
import style0 from "./SearchResourcesPanel.vue?vue&type=style&index=0&id=27fd6cc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd6cc2",
  null
  
)

export default component.exports